<template>
    <div class="GlobalHeader">

        <div class="header flexBetween">
            <div @click="hideMenu" class="" style="font-size:20px;padding:0 24px;cursor:pointer;">
                <i v-if="$store.state.leftmenu" class="el-icon-s-fold"></i>
                <i v-if="!$store.state.leftmenu" class="el-icon-s-unfold"></i>
            </div>

            <div class="headright felxBetween">
                <el-dropdown @command="handleCommand" style="height:100%;">
                    <div class="flexCenter" style="height:100%;">
                        <span style="font-size: 20px; padding-right: 10px">{{ enterInfo.enterName }}</span>
                        <el-tag v-if="enterInfo.enterStatus == 1" size="mini" type="success">已认证</el-tag>
                        <el-tag v-if="enterInfo.enterStatus == 0" size="mini" type="warning">认证中</el-tag>


                        <el-tooltip class="item" effect="dark" :content="enterInfo.remarks" placement="top-end">
                            <el-tag v-if="enterInfo.enterStatus == 2" size="mini" type="danger">
                                认证失败
                            </el-tag>
                        </el-tooltip>



                        <i class="el-icon-arrow-down" style="margin-left:6px;"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="info" icon="el-icon-s-claim">企业资料</el-dropdown-item>
                        <el-dropdown-item command="updPwd" icon="el-icon-edit-outline">修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout" icon="el-icon-set-up">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>

        <el-dialog title="修改密码" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true"
            width="500px">
            <el-form :model="pwdForm">
                <el-form-item>
                    <el-input placeholder="请输入原密码" v-model="pwdForm.oldPwd" auto-complete="off">
                        <template slot="prepend">
                            <span style="display: inline-block; width: 60px">原密码</span>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input type="password" placeholder="请输入新密码" v-model="pwdForm.newPwd1" auto-complete="off">
                        <template slot="prepend">
                            <span style="display: inline-block; width: 60px">新密码</span>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input type="password" placeholder="请再次输入新密码" v-model="pwdForm.newPwd2" auto-complete="off">
                        <template slot="prepend">
                            <span style="display: inline-block; width: 60px">确认密码</span>
                        </template>
                    </el-input>
                </el-form-item>
                <div style="height: 20px;text-align: center;padding-top: 30px;padding-bottom: 20px;">
                    <el-button type="primary" style="width: 100%" @click="savePwd">更改密码</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        enterInfo: {
            type: Object
        },
    },
    data() {
        return {
            defaultActive: "/home",
            isShowModal: false,
            pwdForm: {
                oldPwd: "",
                newPwd1: "",
                newPwd2: ""
            },
            isShowModal: false,
            year: "",
            yearList: [],
            isShowYearModal: false,
            ltmenuHide: true,
            pwdForm: {
                oldPwd: "",
                newPwd1: "",
                newPwd2: "",
            },
            activeIndex: '',
            activeTab: '',
        };
    },
    mounted() { },
    methods: {

        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        hideMenu() {
            if (this.$store.state.leftmenu) {
                this.$store.dispatch("showSmenu", 0)
            } else {
                this.$store.dispatch("showSmenu", 1)
            }
        },
        handleCommand(e) {
            if (e == "updPwd") {
                this.isShowModal = true;
            } else if (e == "logout") {
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push("/login");
            } else if (e == "info") {
                this.$router.push("/enterInfo");
            }
        },

        savePwd() {
            if (!this.pwdForm.oldPwd) {
                this.$message.error("请输入原密码");
                return;
            }

            if (!this.pwdForm.newPwd1) {
                this.$message.error("请输入新密码");
                return;
            }
            if (!this.pwdForm.newPwd2) {
                this.$message.error("请再次输入新密码");
                return;
            }
            if (this.pwdForm.newPwd1 != this.pwdForm.newPwd2) {
                this.$message.error("两次密码不一致");
                return;
            }
            this.$http.post("/api/reset_enterprise_pwd", this.pwdForm).then(ok => {
                if (ok.data.code && ok.data.code != 200) {
                    this.$message.error(ok.data.msg);
                } else {
                    this.$message.success("修改成功");
                    this.isShowModal = false;
                    this.$router.push("/login");
                }
            });
        },
        goPage(item) {
            if (item.path.indexOf('http') < 0) {
                if (this.$route.path != item.path) {
                    this.$router.push(item.path)
                    this.nowsMenu = item.id
                }
            } else {
                if (window.location.href != item.path) {
                    this.nowsMenu = item.id
                    this.$router.push({
                        path: "/iframe",
                        query: {
                            iframeUrl: item.path,
                            t: Date.now(),
                            nowsMenu: item.id,
                        }
                    })

                    this.$store.dispatch("setShowIframe", true)
                    this.$store.dispatch("setIframeUrl", item.path)
                }
            }
        }
    }
};
</script>

<style scoped lang="less" type="text/less">
.GlobalHeader {
    width: 100%;

    .header {
        height: 64px;
        width: 100%;
        background-color: #fff;

        .leftlogo {
            width: 256px;
            /*background-color: #fff;*/

            .thumbnail {
                width: calc(100% - 20px);
                height: 50px;
                overflow: hidden;

                img {
                    max-width: 100%;
                    /*max-height: 100%;
          */
                }
            }
        }

        .hidelogo {
            display: none;
        }

        .moudelname {
            /*margin-left: 20px;*/
            border-left: 4px solid #ffc501;
            color: #ffc501;
            padding-left: 12px;
            font-size: 18px;
            font-weight: bolder;
            white-space: nowrap;
        }

        .menubar {
            margin-left: 20px;
            height: 100%;
            overflow-y: hidden;

            .el-menu-item {
                border-bottom: 4px solid transparent !important;

            }

            .is-active {
                border-bottom: 4px solid #ffc501 !important;
            }

            ul {
                white-space: nowrap;
                height: 100%;

                li {
                    height: 100%;
                    line-height: 50px;
                }
            }

            img {
                width: 100%;
                margin-top: 0px;
            }

            .bmitem {
                height: 100%;
                /*padding: 3px 20px 0px 20px;*/
                border-radius: 4px;
                cursor: pointer;
                display: inline-block;
                vertical-align: top;
                font-weight: bolder;
                margin-right: 10px;
                font-size: 15px;
                color: #fff;

            }

            .bmckd {


                background-size: 100% 100%;
                font-size: 18px;
                color: #fff;
                transform: translateY(-2px);
                font-weight: bolder;

                .ckdline {
                    height: 4px;
                    background-color: #ffcb29;
                    transform: translateY(-8px);
                    border-radius: 2.5px;
                }
            }

        }

        .headright {
            margin: 0 20px 0 30px;
            height: 100%;
            cursor: pointer;

            .nickname {
                margin-left: 10px;
                color: #fff;
                border-radius: 4px;
                cursor: pointer;
                border: 0;
                outline: none;
            }

            .avatarImg {
                width: 30px;
                height: 30px;
                border: 1px solid #0794b3;
                border-radius: 50%;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    cursor: pointer;

                }
            }
        }

    }
}
</style>
